// extracted by css-extract-rspack-plugin
export default {"bottomsheet-content":"JXcpHje___bottomsheet-content","bottomsheetContent":"JXcpHje___bottomsheet-content","title":"CByQtxy___title"};